<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-page-app" id="interactions-microfrontend-container" :style="microfrontendContainerStyle">
    <div v-if="isMicrofrontendLoading" class="microfrontend-loading">
      <div class="loading-spinner">Loading...</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mountInteractionsApp, unmountInteractionsApp } from '../library/wy-micro-frontend.js';
import WyConstants from '../library/wy-constants';

export default Vue.extend({
  name: 'wy-page-app',

  data() {
    return {
      isMicrofrontendLoading: false,
      unmountMicrofrontend: null,
    }
  },

  computed: {
    microfrontendContainerStyle() {
      return {
        width: 'inherit',
        height: 'inherit',
        backgroundColor: 'white',
        zIndex: 1200,
        position: this.isMediaPlayerExpanded ? 'relative' : 'absolute',
        right: this.isMediaPlayerExpanded ? 'auto' : '0'
      };
    },
  },

  methods: {
    initCallback(event) {
      if (event.data.channel === WyConstants.EVENT_MESSAGE_CHANNEL_APP) {
        if (event.data.action === WyConstants.EVENT_MESSAGE_ACTION_APP_INIT_CALLBACK) {
          this.loadMicrofrontend(event.data.info);
        }
      }
    },

   loadMicrofrontend(info) {
      const appUrl = window.location.origin;
      const apiUrl = `${window.location.origin}/studio`;

      try {
        this.isMicrofrontendLoading = true;

        const props = {
          ...info,
          appUrl,
          apiUrl
        };

        this.unmountMicrofrontend = mountInteractionsApp('interactions-microfrontend-container', props);
        this.isMicrofrontendLoading = false;

      } catch (error) {
        console.error('Error mounting microfrontend:', error);
        this.isMicrofrontendLoading = false;
      }
    }, 

    cleanupMicrofrontend() {
      if (this.unmountMicrofrontend) {
        this.unmountMicrofrontend();
        this.unmountMicrofrontend = null;
      } else {
        unmountInteractionsApp('interactions-microfrontend-container');
      }
    }
  },

  created() {
    window.addEventListener('message', this.initCallback);

    if(window.parent) {
      window.parent.postMessage({channel: WyConstants.EVENT_MESSAGE_CHANNEL_APP, action: WyConstants.EVENT_MESSAGE_ACTION_APP_INIT}, '*');
    }
  },

  mounted() {
    //const contactId = 0;

    //this.loadMicrofrontend(contactId);
  },

  beforeDestroy() {
    this.cleanupMicrofrontend();
  }
});
</script>

<style lang="scss">
.wy-page-app {
  width: 100%;
  height: 100%;
}
</style>